/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-03-21 18:18:42
 */
import { createApp } from 'vue'
import 'lib-flexible'
import App from './App.vue'
import {
  Loading,
  ActionSheet,
  RadioGroup,
  Radio,
  Button,
  Skeleton,
  Toast
} from 'vant'

const app = createApp(App)
app.use(Loading)
app.use(ActionSheet)
app.use(RadioGroup)
app.use(Radio)
app.use(Button)
app.use(Skeleton)
app.use(Toast)
app.mount('#app')
